export const lettingFeatureCommand = {
  deleteMany: 'deleteManyLettingFeatures',
};
